module.exports = __webpack_public_path__ + "static/images/technology_1_1.b86b926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_1_1.png
// module id = 2RcW
// module chunks = 8